import React, { useEffect, useState } from 'react';
import './CreateComment.css';
import { addDoc, collection } from "firebase/firestore";
import { db, auth } from './firebase-config';
import { useNavigate } from 'react-router-dom';
import swal from 'sweetalert';







function Suggestion({ isAuth }, props) {

  // let database = "test";

  let database = props.toString();


      database = "suggestions";


  const [title, setTitle] = useState("");
  const [postComment, setPostComment] = useState("");
  const commentCollectionRef = collection(db, database);
  let rating;


  // let rating2;
  //may not need next line
  // let navigate = useNavigate();


  async function writeToDB() {
    try {
      //       if (postRating > 100){
      //     postRating = 100;
      //   }

      // if (postRating === "" ){
      //   postRating = 100;
      // }
      await addDoc(commentCollectionRef, {
        title,
        postComment,
        author: { name: auth.currentUser.displayName, id: auth.currentUser.uid }
      });
      //may not need next line
      // navigate("/");
      // console.log(auth.currentUser);
      // window.location.reload();

    } catch (err) {
      console.error("writeToDB failed. reason:", err);
    }
  }


  // const createComment = async () => {
  // //   if (postRating > 100){
  // //     postRating = 100;
  // //   }

  // // if (postRating === "" ){
  // //   postRating = 100;
  // // }
  // try{
  //   await addDoc(commentCollectionRef, {
  //     title,
  //     postComment,
  //     postRating,
  //     author: { name: auth.currentUser.displayName, id: auth.currentUser.uid }
  //   });
  //   //may not need next line
  //   // navigate("Betrayal-At-House-3rd-Edition");
  //   // console.log(auth.currentUser);
  // } catch(err) {
  //   console.error("writeToDB failed. reason:", err);
  // }

  // };

  // useEffect(() => {
  //   if (!isAuth) {
  //       // navigate("/login");
  //   }
  // }, []);

  return (
    <div className="form-floating mb-3 w-50">

      <div className="">
        <h1>Suggest A Game! </h1>
      </div>
      <form>
        <div className="inputGP">
          <label>Title</label>
          <input className="form-control"
            placeholder="Give comment a title"
            onChange={(event) => {
              setTitle(event.target.value);
            }}></input>
        </div>
        <div className="inputGP">
                   
        </div>
        <div className="inputGP">
          <label>Comment</label>
          <textarea className="form-control" placeholder="Write comment here"
            onChange={(event) => {
              setPostComment(event.target.value);
            }}></textarea>
          {!localStorage.isAuth ? <p>Login to add a suggestion</p> :
            <button onClick={() => {
              writeToDB();

            }}>Submit Comment</button>
          }

          {/* <input type="submit" onClick={createComment}></input> */}

        </div>
      </form>

    </div>
  )
}

export default Suggestion;
